import { FormattedMessage } from 'react-intl';
import { Content } from '../components/Content';
import { PageTitle } from '../components/PageTitle';
import { useIndexedDB } from 'react-indexed-db-hook';
import { Fragment, useEffect, useState } from 'react';
import { DbLogs } from '../type';
import { Empty } from '../components/Empty';
import { Share } from '../components/Share';
import { decompress } from '../helpers/compress';
import { ListTeams } from '../components/ListTeams';

export const Logs = () => {
  const { getAll } = useIndexedDB('draftLogs');
  const [logs, setLogs] = useState<DbLogs[]>([]);

  useEffect(() => {
    getAll<DbLogs>()
      .then((data) => {
        setLogs(data.reverse());
      })
      .catch((err: unknown) => {
        console.error(err);
      });
  }, []);
  const dataShare = {
    url: `${process.env.PUBLIC_URL}/`,
  };

  return (
    <Content justify="start">
      <PageTitle>
        <FormattedMessage id="draftLogs" />
      </PageTitle>
      {logs.length === 0 && (
        <Empty
          icon="logs"
          title="logsEmptyTitle"
          description="logsEmptyDescription"
        >
          <Share data={dataShare} />
        </Empty>
      )}
      {logs.length > 0 &&
        logs.map((l) => {
          const draft = decompress(l.data);
          if (!draft) return;
          return (
            <Fragment key={l.data}>
              <ListTeams draft={draft} token={l.data} status={l.status} />
            </Fragment>
          );
        })}
    </Content>
  );
};
